import { render, staticRenderFns } from "./Bangbangxunwu.vue?vue&type=template&id=e706412e&scoped=true&"
import script from "./Bangbangxunwu.vue?vue&type=script&lang=js&"
export * from "./Bangbangxunwu.vue?vue&type=script&lang=js&"
import style0 from "./Bangbangxunwu.vue?vue&type=style&index=0&id=e706412e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e706412e",
  null
  
)

export default component.exports